import * as XLSX from "xlsx";

// id NON préfixé : conservé tel quel (= PK appointments.id) car réutilisé tel quel
// par handleDelete/handleSave (api.delete/put `/appointments/${target.id}`) — un
// préfixe casserait ces appels. La distinction avec les missions se fait via
// extendedProps.kind, jamais via l'id.
export const mapAppointmentToEvent = (a) => ({
  id: a.id,
  title: `${a.type} - ${a.client}`,
  start: a.date,
  extendedProps: {
    kind: "appointment",
    rawId: a.id,
    client: a.client,
    address: a.address,
    phone: a.phone,
    type: a.type,
    note: a.note || "",
    email: a.email || "",
    status: a.status || "confirmed",
    quoteId: a.quote_id || null,
  },
});

// Mission opérationnelle (post-validation) : affichée en calendrier avec ses infos
// clés (trajet, prix, employés) pour une vision claire des missions prévues.
export const mapMissionToEvent = (m) => ({
  id: `mission-${m.id}`,
  title: `🚚 ${m.client}${m.departure || m.arrival ? ` (${m.departure || "?"} → ${m.arrival || "?"})` : ""}`,
  start: m.date,
  backgroundColor: "#0ea5e9",
  borderColor: "#0ea5e9",
  extendedProps: {
    kind: "mission",
    rawId: m.id,
    client: m.client,
    address: m.address,
    type: m.type,
    departure: m.departure || "",
    arrival: m.arrival || "",
    priceTTC: m.priceTTC,
    employees: Array.isArray(m.employees) ? m.employees.map((e) => e.employee_name).filter(Boolean) : [],
    waybillSentAt: m.waybill_sent_at || null,
  },
});

export const exportToExcel = (data, filename = "data") => {
  if (!data || data.length === 0) return;

  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  XLSX.writeFile(workbook, `${filename}.xlsx`);
};